module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_profile_v2_remoteEntry_mjs_86c776f7__;